/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import * as yup from 'yup';

import {
  LESS_THAN_FIFTY,
  MORE_THAN_TWO
} from '../../constants/home';
import {
  COMMON_ERROR_TEXT,
  OPTION_SEARCH_USER_CONSTANT
} from '../../constants/retriveUserConstant';

const SearchAllQuotesYupSchema = {
  dropdownValue: yup
    .string()
    .oneOf(OPTION_SEARCH_USER_CONSTANT)
    .required(COMMON_ERROR_TEXT),
  searchInput: yup.string().when('dropdownValue', (type: string) => {
    if (type === 'email') {
      return yup.string()
        .required('Email is required')
        .min(3, MORE_THAN_TWO)
        .max(50, LESS_THAN_FIFTY);
    }

    if (type === 'mortgageReference') {
      return yup.string()
        .required('Mortgage Application Number is required')
        .matches(/^\d+$/, 'Please enter a valid Mortgage Application Number')
        .length(8, 'Please enter a valid Mortgage Application Number');
    }

    return yup.string().notRequired();
  })
};

export default SearchAllQuotesYupSchema;
